import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary/ErrorBoundary";
// Load only the font weights we actually use (400, 500, 600, 700)
// This reduces initial bundle size compared to loading all weights
import "@fontsource/finlandica/400.css";
import "@fontsource/finlandica/500.css";
import "@fontsource/finlandica/600.css";
import "@fontsource/finlandica/700.css";
import "./index.css";
import "./i18n/config";

const setAppHeight = () => {
  const height = window.visualViewport?.height ?? window.innerHeight;
  document.documentElement.style.setProperty(
    "--app-height",
    `${Math.round(height)}px`,
  );
};

setAppHeight();
window.addEventListener("resize", setAppHeight);
window.addEventListener("orientationchange", setAppHeight);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);
